export default __webpack_public_path__ + "static/media/AutoAtendimento.b0fba516.svg";